import { ScholarshipStatus } from '@common-types';

import { INITIAL_VALUE } from '@pages/Scholarships/components/SortBy/SortBy';

export const ALL_TYPES_FILTER_VALUE = 'All statuses';

export const FILTER_TAGS_COLORS: { [key: string]: string } = {
  [ALL_TYPES_FILTER_VALUE]: '#464a4f',
  [ScholarshipStatus.IN_PROGRESS]: '#ED6C02',
  [ScholarshipStatus.APPLIED]: '#0C938F',
  [ScholarshipStatus.WINNER]: '#8E2880',
} as const;

export const INITIAL_FILTERS = {
  tagValue: ALL_TYPES_FILTER_VALUE,
  tagColor: FILTER_TAGS_COLORS[ALL_TYPES_FILTER_VALUE],
  sortByValues: INITIAL_VALUE,
};

export const FILTER_TAGS_DATA = [
  {
    value: ALL_TYPES_FILTER_VALUE,
    color: '#464a4f',
  },
  {
    value: ScholarshipStatus.IN_PROGRESS,
    color: FILTER_TAGS_COLORS[ScholarshipStatus.IN_PROGRESS],
  },
  {
    value: ScholarshipStatus.APPLIED,
    color: FILTER_TAGS_COLORS[ScholarshipStatus.APPLIED],
  },
  {
    value: ScholarshipStatus.WINNER,
    color: FILTER_TAGS_COLORS[ScholarshipStatus.WINNER],
  },
];
